import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/css/reset.css";

import http from "@/utils/http";

import VueClipboard from "vue-clipboard2";



// import VConsole from "vconsole";
// import { initPlugin } from 'vue-vconsole-devtools' // for vconsole

// initPlugin(new VConsole());

Vue.use(VueClipboard);

import { Lazyload } from "vant";

Vue.use(Lazyload);

// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
});

import Vant from "vant";
import "vant/lib/index.css";
import "vant/lib/number-keyboard/style";
import "amfe-flexible";
import "./directive/index";
import { Toast } from "vant";
import socketApi from "./utils/socket";

Vue.use(Vant);
Vue.use(Toast);

Vue.config.productionTip = false;

Vue.prototype.socketApi = socketApi;
Vue.prototype.$http = http;

// 云地址
Vue.prototype.cloundUrl = "https://storage.googleapis.com/malaysia-alm/images/";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");


if (process.env.NODE_ENV === "development") {
  Promise.all([import("vconsole"), import("vue-vconsole-devtools")]).then(
    (res) => {
      if (res.length === 2) {
        Vue.config.devtools = true;
        window.__VUE_DEVTOOLS_GLOBAL_HOOK__.emit("init", Vue)
        const VConsole = res[0].default;
        const Devtools = res[1].default;
        Devtools.initPlugin(new VConsole());
      }
    }
  );
}
